// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-breadcrumb>span:last-child a{color:#222222;font-weight:bold}\n", "",{"version":3,"sources":["webpack://./src/pages/Expeditions/Expeditions.scss"],"names":[],"mappings":"AAGA,kCACE,aAAc,CACd,gBAAiB","sourcesContent":["@import \"../../scss/vars\";\n\n\n.ant-breadcrumb > span:last-child a {\n  color: #222222;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
